import React from "react"
import * as graphql from "lib/types/generated/graphql-types"
import FailedRefund from "./FailedRefund"
import { Container } from "../../../../views/Orders/ManageOrder/ManageOrder.styled"
import { OrderSummary } from "./OrderSummary/OrderSummary"
import { Cart } from "./Cart/Cart"
import { Refund } from "../../../../classes/order/Refund"
import PendingRefund from "./PendingRefund"
import { CustomReasonCode } from "lib/types/generated/graphql-types"

type Props = {
  order: graphql.Order
  refetch: () => void
  loading: boolean
  failedRefunds: graphql.OrderRefund[]
  orderHistory: graphql.OrderHistory
  customReasons: CustomReasonCode[]
}

const RefundOrder = ({ order, refetch, loading, failedRefunds, orderHistory, customReasons }: Props) => {
  const refunds = new Refund(order.Refunds)

  if (refunds.pending())
    return (
      <PendingRefund
        pendingRefund={refunds.getPendingRefund()}
        orderRefetch={refetch}
        orderLoading={loading}
      />
    )

  return (
    <>
      {failedRefunds?.length > 0 ? (
        failedRefunds.map((refund: graphql.OrderRefund) => (
          <FailedRefund
            key={refund.id}
            failedRefund={refund}
            currencyCode={order.currencyCode}
            orderId={order.id ?? ""}
            refetch={refetch}
            orderHistory={orderHistory.history}
          />
        ))
      ) : (
        <Container>
          <div>
            <OrderSummary order={order} refetch={refetch} orderLoading={loading} customReasons={customReasons} />
          </div>
          <div>
            <Cart order={order} refetch={refetch} orderLoading={loading} />
          </div>
        </Container>
      )}
    </>
  )
}

export default RefundOrder
